import { useQuery } from '@tanstack/react-query';
import { getPublishedSchedule } from '@/lib/api-schedule';

/** Discover a published agenda without treating permission to read it as existence. */
export function useScheduleAvailability(eventId?: string, userId?: string) {
  return useQuery({
    queryKey: ['schedule', 'avail', eventId, userId ?? 'guest'],
    enabled: Boolean(eventId),
    staleTime: 30_000,
    refetchOnWindowFocus: true,
    retry: false,
    queryFn: async () => {
      const result = await getPublishedSchedule(eventId!);
      if (result.error) throw new Error(result.error.message);
      return {
        available: Boolean(result.data?.revision) || result.data?.unavailable_reason === 'participants',
        restricted: result.data?.unavailable_reason === 'participants',
      };
    },
  });
}
